import { __assign } from "tslib";
import { ErrorPageHeader } from './error-page-header';
import React from 'react';
// @ts-ignore
import s from './error-page.scss';
import { CategoriesCarousel } from '../home/partials/CategoriesCarousel';
import { categoriesCarouselProps } from '../developer-page-container/categoriesCarouselProps';
import { FluidContainer } from '../FluidContainer';
import { composer } from '../../component-decorators/composer';
import { useConfigContext } from '../../config-context';
import { ErrorPageType } from '../..';
import { StatusCode } from '../../enums/marketplace-enums';
import { FontUpgrade } from 'wix-style-react';
export var ErrorPage = composer()
    .withTranslation()
    .compose(function (_a) {
    var appName = _a.appName, categories = _a.categories, errorPageType = _a.errorPageType, t = _a.t;
    // tslint:disable-next-line: react-hooks-nesting
    var configContext = useConfigContext();
    var isNotFoundError = function () {
        return (configContext &&
            configContext.responseCode &&
            errorPageType !== ErrorPageType.INTERNAL_SERVER);
    };
    if (isNotFoundError()) {
        configContext.responseCode(StatusCode.NOT_FOUND);
    }
    return (React.createElement(FontUpgrade, null,
        React.createElement(FluidContainer, { className: s.container },
            React.createElement(ErrorPageHeader, { appName: appName, errorPageType: errorPageType })),
        React.createElement("div", { className: s.carouselContainer },
            React.createElement(CategoriesCarousel, __assign({ className: s.categories }, categoriesCarouselProps(categories, t))))));
});
//# sourceMappingURL=error-page.js.map